"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterIterator = void 0;

var _react = _interopRequireDefault(require("react"));

var _filterState = require("../util/filter-state");

var _jsxRuntime = require("react/jsx-runtime");

var FilterIterator = function FilterIterator(_ref) {
  var _ref$filters = _ref.filters,
      filters = _ref$filters === void 0 ? [] : _ref$filters,
      _ref$activeFilters = _ref.activeFilters,
      activeFilters = _ref$activeFilters === void 0 ? {} : _ref$activeFilters,
      _ref$multiSelectFilte = _ref.multiSelectFilters,
      multiSelectFilters = _ref$multiSelectFilte === void 0 ? [] : _ref$multiSelectFilte,
      _ref$Filter = _ref.Filter,
      Filter = _ref$Filter === void 0 ? function () {
    return null;
  } : _ref$Filter;
  return filters.map(function (_ref2, i) {
    var _ref2$name = _ref2.name,
        name = _ref2$name === void 0 ? '' : _ref2$name,
        _ref2$options = _ref2.options,
        options = _ref2$options === void 0 ? [] : _ref2$options;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(Filter, {
      name: name,
      options: options,
      isSingleOption: (0, _filterState.isFilterSingleOption)(name, options),
      isInUse: (0, _filterState.isFilterInUse)(activeFilters, name),
      multiSelectEnabled: multiSelectFilters.includes(name)
    }, name);
  });
};

exports.FilterIterator = FilterIterator;
//# sourceMappingURL=filter-iterator.js.map